module.exports = {
  title: 'Melih Emik',
  description: 'Melih Emik: cybersecurity, penetration testing, digital forensics tools, certificates, and modern software projects.',
  keywords: 'Melih Emik, melihemik.com.tr, cybersecurity, penetration testing, digital forensics, forensic software, Vue, Go, Rust, C, noirLang',
  url: 'https://melihemik.com.tr/',
  author: 'Melih Emik',
  twitter: '',
  seoImage: 'https://melihemik.com.tr/melihemik.png',
  seoImageAlt: 'Melih Emik website preview',
  color: '#000000',
  sameAs: [
    'https://github.com/melihemik',
    'https://www.instagram.com/melihemik',
    'https://linkedin.com/in/melihemik'
  ],
  email: 'mailto:melihemik@noirlang.tr'
};

// Commit trace: 2026-02-05T10:39:27 - style: adjust formatting in meta.js
